import { exists } from '@/helpers/utilities';

let LazySrc = (() => {
    class LazySrc {
        constructor(node) {
            this.node = node;

            this.nodeExists = exists(this.node);
            if (!this.nodeExists) return;
            this.mode = this.node.tagName;

            this.entryEvent = new CustomEvent('enteredView');
            this.debounceScroll = false;
            this.hasSrc = false;
            this.onScrollBound = this.onScroll.bind(this);
        }

        onImgLoad() {
            setTimeout(() => {
                this.node.classList.add('js-has-src');
            }, 100);
        }

        doImgSrc() {
            let imgSrc = this.node.dataset.lazySrc;
            if (!imgSrc) return;
            this.node.setAttribute('src', imgSrc);
        }

        doSrcSet() {
            let imgSrc = this.node.dataset.lazySrcset;
            if (!imgSrc) return;
            this.node.setAttribute('srcset', imgSrc);
        }

        onVisible() {
            if (this.hasSrc) return;
            this.hasSrc = true;

            if (this.mode == 'IMG') {
                this.doImgSrc();
            }
            if (this.mode == 'SOURCE') {
                this.doSrcSet();
            }
        }

        onScroll() {
            if (this.debounceScroll) return;
            this.debounceScroll = true;

            setTimeout(() => {
                this.debounceScroll = false;
            }, 200);

            let scrollPos = window.scrollY;
            let twoScreenfulls = window.innerHeight * 1.5;
            let offsetScrollPos = scrollPos + twoScreenfulls;
            let elementPos = window.pageYOffset + this.node.getBoundingClientRect().top;

            if (offsetScrollPos > elementPos) {
                this.node.dispatchEvent(this.entryEvent);
            }
        }

        setEventBindings() {
            this.node.addEventListener('enteredView', this.onVisible.bind(this));
            this.node.addEventListener('load', this.onImgLoad.bind(this));
            window.addEventListener('scroll', this.onScroll.bind(this));
        }

        init() {
            if (!this.nodeExists) return;
            this.setEventBindings();
            this.onScroll();
        }
    }

    return {
        init({ selector }) {
            let nodeList = document.querySelectorAll(selector);
            if (!nodeList.length) return;

            return [...nodeList].map((node) => {
                let module = new LazySrc(node);

                module.init();

                return module;
            });
        },
    };
})();

export default Object.create(LazySrc);
